// @ts-nocheck
import dayjs from "dayjs";
import {useMemo} from "react";
import {useNavigate} from "react-router-dom";
import {BaseButton, BaseTable, BaseTypography} from "@/components";
import useGetTickets from "../../hooks/useGetTickets";

const RaffleTickets = () => {
  const {data, isLoading, error} = useGetTickets();
  const navigate = useNavigate();

  const sortedData = useMemo(() => {
    if (!data) return [];
    return [...data].sort((a, b) => dayjs(b.purchase_date).valueOf() - dayjs(a.purchase_date).valueOf());
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleGoBack = () => {
    navigate("/raffles");
  };

  const columns = [
    {
      key: "ticket_number",
      header: "Ticket",
      render: row => row.ticket_number,
    },
    {
      key: "raffleName",
      header: "Rifa",
      render: row => row.raffle?.name,
    },
    {
      key: "ticketPrice",
      header: "Precio",
      render: row => `${row.raffle?.ticket_price / 100} Bs`,
    },
    {
      key: "purchase_date",
      header: "Fecha",
      render: row => dayjs(row.purchase_date).format("DD-MM-YYYY HH:mm"),
    },
  ];

  return (
    <div style={{margin: "var(--space-5)"}}>
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "var(--space-4-5)",
        }}
      >
        <BaseTypography.Title level={5}>Mis Tickets</BaseTypography.Title>
        <BaseButton
          variant="primary"
          onClick={handleGoBack}
        >
          Ver Rifas
        </BaseButton>
      </div>
      <BaseTable
        columns={columns}
        data={sortedData}
        loading={isLoading}
        rowKey="ID"
      />
    </div>
  );
};

export default RaffleTickets;
